var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"placeholder-page"},[_c('el-empty',{attrs:{"description":"APP端技能库正在建设中"}},[_c('el-button',{attrs:{"type":"primary"},on:{"click":_vm.goBack}},[_vm._v("返回首页")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }